import React, { useCallback, useEffect, useMemo } from "react";
import useDesktopMediaQuery from "hooks/useDesktopMediaQuery";
import styles from "./multiplePurchasesPopup.module.css";
import ExlyTable from "common/Components/ExlyTable";
import { useListController } from "react-admin";
import { orgPermissions, RESOURCE_KEYS } from "utils/OrgPermissions";
import { is_empty } from "utils/validations";
import { useNotifications, useToggleState } from "utils/hooks";
import { BroadcastModal } from "common/Components/BroadcastModal/BroadcastModal";
import { useHistory } from "react-router";
import { appendUrlParams } from "utils/urlUtils";
import {
  emptyModalStateProps,
  getBroadcastActions,
} from "../../ListCustomersTableConfig";
import { prepareRecipientList } from "../../../components/helpers";
import {
  getMultiplePurchasesColumnConfig,
  multiplePurchasesFilterConfig,
  MULTIPLE_PURCHASES_FOR_LISTING_RA_PROPS,
} from "./multplePurchasesTableConfig";
import { WhatsAppButton } from "webpage-leads/components/CustomColumns";
import ExlyModal from "common/Components/ExlyModal";
import SessionStorageConstants from "constants/SessionStorage.constants";

const commonProps = { modalPaperClassName: styles.root, customFooter: <></> };

const MultiplePurchasesPopup = ({ open, onClose, listingUuid }) => {
  const {
    filterValues,
    loaded,
    data,
    selectedIds,

    onSelect,
  } = useListController({
    ...MULTIPLE_PURCHASES_FOR_LISTING_RA_PROPS,
  });
  useEffect(() => {
    if (listingUuid) {
      localStorage.setItem(
        SessionStorageConstants.PROMOTIONAL_LISTING,
        listingUuid
      );
      sessionStorage.setItem(SessionStorageConstants.MULTIPLE_PURCHASES, true);
    }
  }, [listingUuid]);

  const isDesktop = useDesktopMediaQuery();
  const history = useHistory();
  const canSendWhatsapp = orgPermissions.hasFeatureWriteAccess(
    RESOURCE_KEYS.SECTIONS.WHATSAPP_BROADCASTS
  );
  const [isBroadcastModalActive, showBroadcastModal, hideBroadcastModal] =
    useToggleState(false);
  const { notify } = useNotifications();
  const isEmptySelectedIds = is_empty(selectedIds);

  const canSendEmail = orgPermissions.hasFeatureWriteAccess(
    RESOURCE_KEYS.SECTIONS.CUSTOM_MAILS
  );
  const isEmpty = loaded && is_empty(data) && is_empty(filterValues);

  const canBroadcastMessage = (canSendEmail || canSendWhatsapp) && !isEmpty;
  const sendWhatsappBroadcast = useCallback(() => {
    if (isEmptySelectedIds) return notify("No contact selected!", "error");

    const phoneNumberList = selectedIds.map(
      (i) => `${data[i]?.country_code}${data[i]?.phone_number}`
    );

    history.push(
      appendUrlParams("/whatsapp-broadcasts/select", {
        preselected_numbers: encodeURIComponent(phoneNumberList.join(",")),
      })
    );
  }, [selectedIds]);

  const sendEmail = useCallback(() => {
    if (isDesktop && isEmptySelectedIds)
      return notify("No contact selected!", "error");

    prepareRecipientList(data, selectedIds);
  }, [selectedIds, data]);

  const broadcastActions = useMemo(() => {
    return getBroadcastActions({
      sendEmail,
      sendWhatsappBroadcast,
    });
  }, [sendEmail, sendWhatsappBroadcast, selectedIds, data]);

  const footerProps = {
    primarybtn: "Send Message",
    primaryClick: showBroadcastModal,
    hidePrimarybtn: !canBroadcastMessage,
  };

  const columnConfig = useMemo(() => getMultiplePurchasesColumnConfig(), []);

  const bookingsTitle = useMemo(
    () => <div className={styles.bookingTitleWrapper}>Loyal Customers </div>,
    []
  );

  const sendMessageButtonProps = {
    onClick: showBroadcastModal,
    disabled: isEmpty,
  };

  return (
    <ExlyModal
      open={open}
      modal_props={commonProps}
      mobile_modal_props={{
        paperClassName: styles.modalPaper,
        escapeKeyDownClose: true,
        ...commonProps,
      }}
      onClose={onClose}
      title={bookingsTitle}
    >
      <div className={styles.mobileModalDivWrapper}>
        <ExlyTable
          ra_props={{
            ...MULTIPLE_PURCHASES_FOR_LISTING_RA_PROPS,
          }}
          noExportButton
          layoutProps={{
            paddingDesktop: "0",
            layoutDesktopMargin: "20px 0px 20px 0px",
            layoutMobileMargin: "0",
            paddingMobile: "0px",
            noMobileBoxShadow: true,
          }}
          showFiltersOnEmptyList={true}
          sendMessageButtonProps={sendMessageButtonProps}
          showSendMessageButton={isDesktop && canBroadcastMessage}
          renderPrimaryColumnRightNode={(record) => {
            return (
              <>
                {is_empty(record.phone_number) ? null : (
                  <WhatsAppButton
                    record={record}
                    source="phone_number"
                    countryCodeKey="country_code"
                  />
                )}
              </>
            );
          }}
          checkboxSelection
          selected={selectedIds}
          onRowSelected={onSelect}
          columnConfig={columnConfig}
          tableFilters={multiplePurchasesFilterConfig}
          showSelectAllcheckBox={true}
          hasMobileFooter={true}
          footerProps={footerProps}
          borderedFields
          fieldsLeftPadded
          drawerFieldsBordered
          fieldsAlignment="space-between"
          drawerFieldsAlignment="space-between"
          recordFooterVariant="secondary"
          primaryKey="id"
          {...emptyModalStateProps}
        />
        {canBroadcastMessage && isBroadcastModalActive && (
          <BroadcastModal
            open={isBroadcastModalActive}
            onClose={hideBroadcastModal}
            modal_props={{ title: "Send Message" }}
            mobile_modal_props={{ header: "Select Broadcast medium" }}
            broadcastActions={broadcastActions}
          />
        )}
      </div>
    </ExlyModal>
  );
};

export default MultiplePurchasesPopup;
